import { SchemaField } from '../../../objects/generic/serialization/schema-field';
import { SerializableObjectSchema } from '../../../objects/generic/serialization/serializable-object-schema';

export class RequestSchema extends SerializableObjectSchema {
  ////////////////////////////////////////////////////////////////////////////////////////////////
  // Constants
  ////////////////////////////////////////////////////////////////////////////////////////////////

  public static readonly idempotencyToken = 'idempotencyToken';

  ////////////////////////////////////////////////////////////////////////////////////////////////
  // Constants
  ////////////////////////////////////////////////////////////////////////////////////////////////

  static GenericDefaults = class {
    public static readonly idempotencyToken = undefined;
  };

  ////////////////////////////////////////////////////////////////////////////////////////////////
  // Schema Parameters
  ////////////////////////////////////////////////////////////////////////////////////////////////

  public getSchemaDefinition(): { [key: string]: import('joi').AnySchema } {
    const parameters = {} as any;

    /* eslint-disable */
    parameters[RequestSchema.idempotencyToken] = SchemaField.string(RequestSchema.GenericDefaults.idempotencyToken);
    /* eslint-enable */

    return parameters;
  }
}
